module.exports = __webpack_public_path__ + "media/images/lp/history1-sp-896133fdbbd410d4c67f0435a258f002.jpg";